import * as React from "react";
import * as moment from "moment";
import { MonthStatistics, Statistics } from "./StatsModel";

export interface MonthlyStatsProps {
  months: Array<MonthStatistics>;
}

export default class MonthlyStatsView extends React.Component<
  MonthlyStatsProps,
  {}
> {
  constructor(props) {
    super(props);
  }

  render() {
    const rows = this.props.months
      .sort((m1, m2) => (m1.month.isAfter(m2.month) ? -1 : 1))
      .map(month => {
        const monthKey = month.month.format("YYYY-MM");
        const monthTopLinks = month.top
          .sort((link1, link2) => link2.clicks - link1.clicks)
          .map(l => {
            return (
              <li key={l.id}>
                <a href={l.url}>{l.title}</a> ({l.clicks})
              </li>
            );
          });

        return (
          <tr key={monthKey}>
            <td>
              {month.month.format("MMMM YYYY")}
            </td>
            <td>
              <div>
                <ul>
                  {monthTopLinks}
                </ul>
              </div>
            </td>
          </tr>
        );
      });

    return (
      <div>
        <table>
          <thead>
            <tr>
              <th>Month</th>
              <th>Top links</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stats/MonthlyStatsView.tsx